import React, { useCallback, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RestaurantNavItem } from "./RestaurantNavComponents/RestaurantNavItem";
import "../css/RestaurantNav.css";
import HamburgerIcon from "./icons/HamburgerIcon";
import MobileNavModal from "./ModalComponents/MobileNavModal";

/**
 * Format of RestaurantNav:
 * Header with Logo and Company Name
 *
 * Core Items --> dashboard, menu, report
 *
 * Footer Items --> help, profile
 *
 * Props:
 * itemNames: Array of strings
 * itemIcons: Array of React components
 * footerItemNames: Array of strings
 * footerItemIcons: Array of React components
 */

const RestaurantNav = (props) => {
  const itemNames = props.itemNames || [];
  const itemIcons = props.itemIcons || [];
  const footerItemNames = props.footerItemNames || [];
  const footerItemIcons = props.footerItemIcons || [];
  const secondaryFooterItemIcons = props.secondaryFooterItemIcons || [];
  const activePage = props.activePage || "menu";
  const fontColor = props.fontColor || "#f9b09b";

  const [activeItem, setActiveItem] = useState(activePage);
  const isMobile = useSelector((state) => state.mobile.isMobile);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleItemClick = useCallback((name) => {
    setActiveItem(name);
    setIsModalOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setIsModalOpen((prev) => !prev);
  }, []);

  return (
    <div className="RestaurantNav">
      <div className="restaurant-nav-header">
        <img className="logo" src="/logo.png" alt="tastelens" />
        <h3 className="company-name">tastelens</h3>

        {isMobile && (
          <div className="hamburger-icon" onClick={toggleModal}>
            <HamburgerIcon color={fontColor} />
          </div>
        )}
      </div>

      {isMobile && (
        <MobileNavModal
          isOpen={isModalOpen}
          onRequestClose={toggleModal}
          coreItems={itemNames}
          footerItems={footerItemNames}
          onItemClick={handleItemClick}
          fontColor={fontColor}
        />
      )}

      {!isMobile && (
        <>
          <div className="restaurant-nav-core-items">
            {itemNames.map((name, index) => (
              <div className="restaurant-nav-item" key={index}>
                <RestaurantNavItem
                  name={name}
                  icon={itemIcons[index]}
                  onClick={handleItemClick}
                  active={activeItem === name}
                />
              </div>
            ))}
          </div>

          <div className="restaurant-nav-footer-items">
            {footerItemNames.map((name, index) => (
              <div className="restaurant-nav-item" key={index}>
                <RestaurantNavItem
                  name={name}
                  icon={footerItemIcons[index]}
                  onClick={handleItemClick}
                  active={activeItem === name}
                  secondaryIcon={secondaryFooterItemIcons[index]}
                />
                {index == 0 && <hr style={{ border: "2px solid white" }} />}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default RestaurantNav;
